import { Private_Routes } from '@common/url';

import { MeteringInfo } from './types';

export const defaultMeteringInfo: MeteringInfo = {
  activatedUsers: 0,
  additionalUsers: 0,
  creditsBreakdown: {
    additionalUsersCredits: 0,
    dataEgressedCredits: 0,
    dataProcessedCredits: 0,
    dataStoredCredits: 0,
    totalCreditsConsumed: 0
  },
  creditsConsumed: 0,
  creditsCostPerAdditionalUser: 0,
  creditsCostPerGBEgressed: 0,
  creditsCostPerGBProcessed: 0,
  creditsCostPerGBStoredPerMonth: 0,
  executionPlanesCredits: [],
  from: '',
  to: '',
  includedUsers: 0,
  pricePerCredit: 0,
  totalCreditsAllocated: 0,
  totalStorageProcessed: 0,
  totalUsers: 0,
  updated_at: '',
  tenantName: ''
};

export const USAGE_AND_BILLING_PAGE = Private_Routes.Settings.tab.getUrl({ tab: 'usage&Billing' });
